//#region Libraries
import {
    useNavigate 
} from "react-router";
//#endregion
//#region Styles
import {  
    Part } from "components/styles";
import {  
    Observations,
    BackToManualLoading } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import warningIcon from "img/warning_icon.svg";
//#endregion


const Part1 = () => {
    const navigate = useNavigate();
    //#region Functions
    const toManualLoading = () => {
        navigate("/eventos/crear/carga-manual");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    //#endregion
    return (
        <Part gap="20px">
            <Observations>
                <header>
                    <img src={warningIcon} alt="Ícono de advertencia de la UTP"/>
                    <h2>Obvervaciones para crear tu evento masivo</h2>
                </header>
                <ul>
                    <li>
                        Los eventos por carga masiva son por el período de un día
                    </li>  
                    <li>
                        Recuerda que aquí solo puedes crear únicamente un tipo de evento
                    </li>
                </ul>
            </Observations>
            <BackToManualLoading>
                <h2>A tener en cuenta...</h2>
                <li>Si quieres crear eventos de varios días y diferentes horas, tendrás que hacerlo por carga manual</li>
                <CustomButton
                    variant="quaternary"
                    text="Crear evento manual"
                    onClick={toManualLoading}/>
            </BackToManualLoading>
        </Part>
    );
}

export default Part1;